import { useState } from 'react';
import useFormValidator from './formValidatorHook';

export default function useForm(initFormData, rules) {    
    const [formData, setFormData] = useState(initFormData);
    const { errorMapping, validate } = useFormValidator(Object.fromEntries(Object.keys(initFormData).map(name => [name, ''])), rules);

    const handleChange = (e) => {
        e.preventDefault();
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = (e, successHandler) => {
        e.preventDefault();
        if (rules) { // No rules means no validation!
            if (validate(formData)) {
                if (successHandler) {
                    successHandler();
                }
            }
        }
        else {
            if (successHandler) {
                successHandler();
            }
        }
    }

    return { formData, setFormData, handleChange, errorMapping, handleSubmit };
}